export default "__VITE_ASSET__3b12d2ce__"